import { render, staticRenderFns } from "./InsElMenu.vue?vue&type=template&id=42705e67&scoped=true"
import script from "./InsElMenu.vue?vue&type=script&lang=ts"
export * from "./InsElMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42705e67",
  null
  
)

export default component.exports